import React from 'react';
import { observer } from 'mobx-react';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { LauncherPositions } from '@gamiphy/bl/theme';
import { Grid } from '@mui/material';
import { useMobile } from '@gamiphy/loyalty-station-desktop/utils/mobile';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import GiftIcon from './GiftIcon';
import Title from './Title';

const FloatingIcon: React.FC = observer(() => {
  const [showTitle, setShowTitle] = React.useState(false);

  const changeShowTitle = (visibile: boolean) => {
    setShowTitle(visibile);
  };

  const iconPosition = React.useMemo<string>(() => {
    switch (ThemeStore.theme.launcher.position.mobile) {
      case LauncherPositions.right:
      case LauncherPositions.topRight:
      case LauncherPositions.bottomRight:
        return AppStore.dir === 'rtl' ? 'flex-start' : 'flex-end';
      case LauncherPositions.top:
      case LauncherPositions.bottom:
        return 'center';
      default:
        return AppStore.dir === 'rtl' ? 'flex-end' : 'flex-start';
    }
  }, [ThemeStore.theme.launcher.position.mobile]);
  const isMobile = useMobile();

  return (
    <Grid
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: (!isMobile ? 'flex-start' : iconPosition),
      }}
    >
      <GiftIcon changeShowTitle={changeShowTitle} />
      {showTitle && <Title />}
    </Grid>
  );
});

export default FloatingIcon;
